import React, {Component} from 'react';
import {Redirect, Route} from 'react-router-dom';

export default class PrivateRoute extends Component {
    render() {
        if (localStorage.getItem('authToken') === null) {
            return <Redirect to="/user/login"/>;
        }
        ;
        return (
            <Route {...this.props}>
                this.props.children
            </Route>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.jsx